import { useEffect, useState } from "react";
import LogoImage from "../assets/images/logo.png";
import axiosConfig from "./axiosConfig";
import SabbatRefereeSideInfo from "./SabbatRefereeSideInfo";
import RefereeRows from "./RefereeRows";
import SabbatRow from "./SabbatRow";
import Timer from "./timer";
import RoundTimer from "./roundTimer";
import { useQuery } from "react-query";
import numberToPersian from "./NumberToPersian";

const SabbatReferee = (props) => {
  const [basicdata, setBasicdata] = useState({
    playcode: null,
    fullname_red: null,
    fullname_blue: null,
  });
  const [inputs, setInputs] = useState({
    winner: "",
    wintype: "points",
  });

  const [totalWinner, setTotalWinner] = useState("");

  const [matchState, setMatchState] = useState("true");
  const [endRoundBtn, setEndRoundBtn] = useState(false);
  const [queryRun, setQueryRun] = useState(true);
  const [mainMinute, setMainMinute] = useState(1);
  const [mainSecond, setMainSecond] = useState(30);

  const [roundMinute, setRoundMinute] = useState(1);
  const [roundSecond, setRoundSecond] = useState(0);

  const localPlaycode = localStorage.getItem("playcode");

  async function fetchData() {
    let response = await axiosConfig(
      "sabbat-basicdata.php?playcode=" + localPlaycode
    );
    let user = await response.data;
    console.log("User = ", user);
    setBasicdata(user.basicdata);
    setMainMinute(user.timeData.match_minute);
    setMainSecond(user.timeData.match_second);
    setRoundMinute(user.timeData.round_minute);
    setRoundSecond(user.timeData.round_second);
  }
  useEffect(() => {
    if (localStorage.getItem("playcode") === null) {
      props.history.replace("/");
    } else {
      fetchData();
    }
  }, []);

  const refreshPage = () => {
    window.location.reload(true);
  };

  function endRoundHandler(round) {
    if (headInfo.play_status === "pause") {
      setMainMinute(1);
      setMainSecond(30);
      setRoundMinute(1);
      setRoundSecond(0);
      try {
        setEndRoundBtn(true);
        axiosConfig
          .get("end-round.php?playcode=" + localPlaycode + "&round=" + round)
          .then((response) => {
            console.log("End Round Response= ", response);
            if (round < 3) {
              setEndRoundBtn(false);
            }
          });
      } catch (error) {
        console.log(error.errors);
        setEndRoundBtn(false);
      }
    } else {
      alert("برای پایان راند، باید تایمر بازی در حالت وقفه باشد!");
    }
  }

  function registerFinalResult(playcode, wintype, winner) {
    try {
      axiosConfig
        .get(
          "register-final-result.php?playcode=" +
            playcode +
            "&wintype=" +
            wintype +
            "&winner=" +
            winner
        )
        .then((response) => {
          console.log("final result response= ", response.data);
          // setQueryRun(false);
          setTimeout(setQueryRun(false), 5000);
          setTotalWinner(response.data.total_winner);
          console.log("final result totalWinner = ", totalWinner);
        });
    } catch (error) {
      console.log(error.errors);
    }
  }

  const { status, data, error, isFetching } = useQuery(
    "todos",
    async () => {
      const { data } = await axiosConfig.get(
        "get-points-sabbat.php?playcode=" + localPlaycode
      );
      return data;
    },
    {
      refetchInterval: 1000,
      enabled: queryRun,
    }
  );

  let roundNumber = 1;
  let referees = [];
  let headInfo = [];
  // let matchState = true;
  if (status === "success") {
    console.log(data);
    roundNumber = data.roundnumber;
    referees = data.referees;
    headInfo = data.headinfo;
    // matchState = data.match_state;

    let loginStatus = data.status;
    if (loginStatus === 0) {
      console.log("Status = ", loginStatus);
    }
  }

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    const newInputs = { ...inputs };
    newInputs[name] = value;
    setInputs(newInputs);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(inputs);
    let { wintype, winner } = inputs;
    if (winner == "" || winner == null) {
      alert("لطفا ابتدا برنده را مشخص کنید!");
    } else {
      registerFinalResult(localPlaycode, wintype, winner);
      setMatchState("false");
    }
  };

  let winner = "";

  function exitHandler(playcode) {
    try {
      axiosConfig
        .get("exit-match.php?playcode=" + playcode)
        .then((response) => {
          console.log("Next match response= ", response);
          if (response.data.status === 0) {
            alert(
              "مشکلی رخ داده است! بصورت دستی با کد بازی بعدی وارد سامانه شوید."
            );
          } else if (response.data.status > 0) {
            console.log("Next match!");
            localStorage.setItem("playcode", response.data.playcode);
            setBasicdata(response.data.basicdata);
            fetchData();
            setMatchState("true");
            setTimeout(setQueryRun(true), 15000);
            refreshPage();
            //props.history.replace("/SabbatReferee");
          }
        });
    } catch (error) {
      console.log(error.errors);
    }
  }

  function resetPoints(roundNumber) {
    try {
      axiosConfig
        .get("reset-points.php?playcode=" + playcode + "&round=" + roundNumber)
        .then((response) => {
          console.log("response= ", response);
        });
    } catch (error) {
      console.log(error.errors);
    }
  }


  const enterNextCode = () => {
    props.history.replace("/LoginPage");
  };



  let btnDisable = "";
  let endBox = "dontshow";
  if (matchState === "false") {
    btnDisable = "dontshow";
    endBox = "";
  } else if (matchState === "true") {
    btnDisable = "";
    endBox = "dontshow";
  }

  let { playcode, fullname_red, fullname_blue } = basicdata;

  console.log(headInfo.play_status);

  return (
    <>
      <div className="myNavbar">
        <div className="logo">
          <img src={LogoImage} alt="logo" />
        </div>
        <div className="details">
          <button
            className={"btn btn-secondary btn-sm " + btnDisable}
            onClick={() => resetPoints(roundNumber)}
            title="صفر کردن امتیازات این راند"
          >
            صفر کردن امتیازات
          </button>{" "}
          &nbsp;
          {roundNumber < 4 && (
            <button
              className={"btn btn-sm btn-info " + btnDisable}
              disabled={endRoundBtn}
              onClick={() => endRoundHandler(roundNumber)}
            >
              پایان این راند
            </button>
          )}
        </div>
      </div>
      <div className="container-full">
        <div className="row mt-1 pb-5 text-center" style={{ direction: "rtl" }}>
          <div
            className="col-10"
            style={{ textAlign: "right", direction: "rtl" }}
          >
            <table
              className="table table-striped table-hover table-bordered IRANSansNormal"
              style={{
                textAlign: "center",
                direction: "rtl",
                fontSize: "13px",
              }}
            >
              <thead>
              <tr>
                  <th rowSpan="3">شماره</th>
                  <th colSpan="6" className="bg-primary text-white">
                    {headInfo.team_blue}
                  </th>
                  <th colSpan="6" className="bg-danger text-white">
                    {headInfo.team_red}
                  </th>
                  <th rowSpan="3">برنده راند</th>
                </tr>
                <tr>
                  {/* <th rowSpan="2">شماره</th> */}
                  <th colSpan="6" className="bg-primary text-white">
                    {fullname_blue} ({headInfo.userweight_blue})
                  </th>
                  <th colSpan="6" className="bg-danger text-white">
                    {fullname_red} ({headInfo.userweight_red})
                  </th>
                  {/* <th rowSpan="2">برنده راند</th> */}
                </tr>
                <tr>
                  <th>امتیاز این راند</th>
                  <th>تذکر</th>
                  <th>اخطار</th>
                  <th>بیرون</th>
                  <th>ناک دان</th>
                  <th>زمین خوردن</th>
                  <th>امتیاز این راند</th>
                  <th>تذکر</th>
                  <th>اخطار</th>
                  <th>بیرون</th>
                  <th>ناک دان</th>
                  <th>زمین خوردن</th>
                </tr>
              </thead>
              <tbody>
                {referees.map((p, i) => (
                  <RefereeRows
                    key={i}
                    refereeid={p.id}
                    refereeNo={p.number}
                    redPoint={p.redpoint}
                    bluePoint={p.bluepoint}
                    round_a_winner={p.round_a_winner}
                    round_b_winner={p.round_b_winner}
                    round_c_winner={p.round_c_winner}
                    total_winner={p.total_winner}
                    disableState={btnDisable}
                  />
                ))}
                <SabbatRow headInfo={headInfo} disableState={btnDisable} />
              </tbody>
            </table>
            <div className="row mt-4">
              <div className="col-md-6 col-6">
                {/* {headInfo.play_status !== "round" && ( */}
                <Timer
                  mainminute={mainMinute}
                  mainsecond={mainSecond}
                  playState={headInfo.play_status}
                />
                {/* )} */}
              </div>
              <div className="col-md-6 col-6">
                {headInfo.play_status === "round" && (
                  <RoundTimer
                    roundminute={roundMinute}
                    roundsecond={roundSecond}
                  />
                )}
              </div>
            </div>

            {matchState == "true" && (
              <form onSubmit={handleSubmit}>
                <div
                  className="row endmatch mt-3"
                  style={{ display: "flex", flexDirection: "end" }}
                >
                  <p
                    className="IRANSansMedium mt-2 mb-3"
                    style={{
                      fontSize: "13px",
                      textAlign: "right",
                      direction: "rtl",
                    }}
                  >
                    جهت ثبت نتیجه و اعلام پایان بازی به سیستم و امکان شروع بازی
                    های بعدی و همچنین بدلیل جلوگیری از بروز اشکال در سیستم
                    داوری, حتما پایان بازی را از طریق فرم زیر اعلام نماپید.
                  </p>
                  <div className="col-3">
                    <label
                      htmlFor="wintype"
                      className="IRANSansMedium"
                      style={{
                        width: "100%",
                        textAlign: "right",
                        direction: "rtl",
                        fontSize: "13px",
                      }}
                    >
                      نوع برد
                    </label>
                    <select
                      value={inputs.wintype}
                      className="form-control IRANSansNormal"
                      style={{ direction: "rtl", fontSize: "13px" }}
                      name="wintype"
                      id="wintype"
                      onChange={handleChange}
                    >
                      <option value="points">امتیازی</option>
                      <option value="harif">عدم حضور رقیب</option>
                      <option value="ndown">ناک دان</option>
                      <option value="nout">ناک اوت</option>
                    </select>
                  </div>
                  <div className="col-3">
                    <label
                      htmlFor="winner"
                      className="IRANSansMedium"
                      style={{
                        width: "100%",
                        textAlign: "right",
                        direction: "rtl",
                        fontSize: "13px",
                      }}
                    >
                      برنده
                    </label>
                    <select
                      value={inputs.winner === "" ? winner : inputs.winner}
                      className="form-control IRANSansNormal"
                      style={{ direction: "rtl", fontSize: "13px" }}
                      name="winner"
                      id="winner"
                      onChange={handleChange}
                    >
                      <option value=""></option>
                      <option value="red">{fullname_red} (قرمز) </option>
                      <option value="blue">{fullname_blue} (آبی) </option>
                    </select>
                  </div>
                  <div className="col-3">
                    <button className="btn btn-danger btn-sm mt-4">
                      پایان مسابقه و ثبت نتیجه
                    </button>
                  </div>
                </div>
              </form>
            )}
            <div className={"row justify-content-md-center mt-4 " + endBox}>
              <div
                className=" col-6 col-md-6"
                style={{
                  textAlign: "center",
                  border: "1px solid #999",
                  padding: "5px 5px 10px 5px",
                  background: "#ffcc00",
                  boxShadow: "4px 7px 4px #999",
                }}
              >
                <p
                  className="mt-3 IRANSansNormal text-black"
                  style={{ direction: "rtl", fontSize: "14px" }}
                >
                  این مسابقه پایان یافته است! جهت برگزاری بازی بعدی بر روی دکمه
                  زیر کلیک کنید.
                </p>
                <button className="btn btn-info btn-sm IRANSansNormal mt-3" onClick={enterNextCode}>
                ورود کد بازی بعد
              </button>{" "}
              &nbsp;
                <button
                  className="btn btn-danger btn-sm IRANSansNormal mt-3"
                  onClick={() => exitHandler(localPlaycode)}
                >
                  بازی بعدی
                </button>
              </div>
            </div>
          </div>
          <SabbatRefereeSideInfo
            athleteFullname={{
              fullname_red: fullname_red,
              fullname_blue: fullname_blue,
            }}
            playCode={localPlaycode}
            roundNumber={roundNumber}
            totalData={headInfo}
            getTotalWinner={totalWinner}
          />
        </div>
      </div>
    </>
  );
};

export default SabbatReferee;
